import { DocumentDb } from 'src/interfaces/EscritosLegales'
import { Document } from 'src/interfaces/lexon'

type useDocumentOutput = {
  mapFromDb: (data: any) => Document
}

export default function useDocument(): useDocumentOutput {
  const mapFromDb = (data: DocumentDb): Document => {
    const document: Document = {} as Document
    document.id = data.IdDocumento?.toString() ? data.IdDocumento?.toString() : ''
    document.name = data.Nombre ? data.Nombre : ''
    document.description = data.Descripcion ? data.Descripcion : ''
    document.initialFile = data.ArchivoInicial ? data.ArchivoInicial : ''
    return document
  }

  return {
    mapFromDb
  }
}
